import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-session-time-out-utf',
    templateUrl: './session-time-out-utf.component.html',
    styleUrls: ['./session-time-out-utf.component.scss'],
    standalone: false
})
export class SessionTimeOutUtfComponent extends CfetBaseComponent implements OnInit {
  openPopUp = '';
  showSessionPopUp = true;

  constructor(private title: Title) { super(); }

  ngOnInit () {
    setTimeout(() => {
      this.openPopUp = 'open';
    }, 100);
    this.title.setTitle(this.cfetTitles.timeout.htmlTitle);
    window.scroll(0, 0);
  }

  closeSessionTimeOut (event) {
    if (event === 'modalClose') {
      this.openPopUp = 'close';
    }
  }
}
